import { Navigate, RouteObject } from 'react-router-dom'
import { SafetyPage } from './safety'
import { SafetyLagging } from './safety-lagging'
import { SafetyTotal } from './safety-total'
import { SafetyLeading } from './safety-leading'
import { SafetyStore } from './safety-store'
import { useEssentials } from 'hooks/utils/useEssentials'
import { isStore } from 'utils/location'

export const ProtectedStoreRoute = () => {
    const { currentLocation } = useEssentials()

    if (!isStore(currentLocation)) {
        return <Navigate to="/safety/lagging" replace />
    }

    return <SafetyStore />
}

export const SafetyRoute: RouteObject = {
    path: '/safety',
    element: <SafetyPage />,
    children: [
        {
            index: true,
            element: <Navigate to="lagging" replace />,
        },
        {
            path: 'lagging',
            element: <SafetyLagging />,
        },
        {
            path: 'total',
            element: <SafetyTotal />,
        },
        {
            path: 'leading',
            element: <SafetyLeading />,
        },
        {
            path: 'store',
            element: <ProtectedStoreRoute />,
        },
    ],
}
